'use strict';
module.exports = require('./Knob.vue');